"use strict";
import "lodash";
import { svc_addOne, svc_fetchOne, svc_editOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import config from "@/../config/config.json";

const endpointBasePrefix = "xero/invoice";

const Model = {
	namespace: "m_XeroInvoice",
	state: {
		xeroInvoice: {},
		invoices: [],
		xeroInvoiceTypes: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { invoices } }) {
			return { ...state, invoices };
		},
		handleFetchOne(state, { payload }) {
			return { ...state, xeroInvoice: payload };
		},
		handleFetchAllTypes(state, { payload }) {
			return { ...state, xeroInvoiceTypes: payload };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			const invoices = yield call(svc_search, `${endpointBasePrefix}`, payload);

			_.forEach(invoices.result, function (row) {
				row.key = row.id;
				row.name = row.contact.name;
				row.brandName = row.brand.name;
				row.outletName = row.outlet.name;
				row.accounting_date = convertISODateTimeToString(row.accounting_date, null, config.dateFormat);
				row.posted_date = convertISODateTimeToString(row.posted_date, null, config.dateTimeFormat);
				row.created_at = convertISODateTimeToString(row.created_at, null, config.dateTimeFormat);

				// setting the button
				if (row.status === "FAILED_TO_POST" || row.status === "READY_TO_POST") {
					row.hideCancelledBtn = false;
				} else {
					row.hideCancelledBtn = true;
				}
			});

			yield put({
				type: "handleFetchAll",
				payload: { invoices },
			});
		},

		// return one xero invoice details
		*fetchOne({ searchKey, payload }, { call, put }) {
			if (!searchKey && payload) {
				searchKey = payload;
			}
			const response = yield call(svc_fetchOne, endpointBasePrefix, searchKey);
			showServerResponse(invoice, true);

			let invoice;
			if (response.result && response.result.length == 1) {
				response.result[0].line_amount_total = 0;
				_.forEach(response.result[0].details, (row) => {
					row.key = row.id;
					response.result[0].line_amount_total += Number(row.line_amount);
					row.line_amount_string = row.line_amount.toLocaleString("en", { 
						minimumFractionDigits: 2,
						maximumFractionDigits: 2 
					});
				});
				response.result[0].line_amount_total_string = response.result[0].line_amount_total.toLocaleString("en", { 
					minimumFractionDigits: 2,
					maximumFractionDigits: 2 
				});
				invoice = response.result[0];
			}

			yield put({
				type: "handleFetchOne",
				payload: invoice,
			});

			return invoice;
		},

		// post / repost of invoices 
		*postInvoice({ payload }, { call }) {
			const response = yield call(svc_addOne, `${endpointBasePrefix}/post`, payload);
			showServerResponse(response);
			return response;
		},

		// cancellation of invoices 
		*voidInvoice({ payload }, { call }) {
			const response = yield call(svc_addOne, `${endpointBasePrefix}/cancel`, payload);
			showServerResponse(response);
			return response;
		},

		*fetchAllTypes({ }, { call, put }) {
			const types = yield call(svc_search, `${endpointBasePrefix}-type`);
			_.forEach(types.result, function (row) {
				row.key = row.id;
				row.typeDescription = `${row.code} - ${row.description}`;
			});

			yield put({
				type: "handleFetchAllTypes",
				payload: types.result,
			});

			return types.result;
		},

		// return latest xero invoice from specific config id
		*fetchOneConfig({ searchKey, payload }, { call, put }) {
			if (!searchKey && payload) {
				searchKey = payload;
			}
			const response = yield call(svc_fetchOne, `${endpointBasePrefix}/latest`, searchKey);
			showServerResponse(invoice, true);

			let invoice;
			if (response.result && response.result.length == 1) {
				invoice = response.result[0];
			}

			return invoice;
		},
	},
	subscriptions: {
		setup({ dispatch, history }) {
			return history.listen(({ pathname }) => {
				if (pathname.includes("/xero/invoices/view/")) {
					const payload = pathname.split("/")[4];
					dispatch({ type: "fetchOne", payload });
				}
			});
		},
	},
};

export default Model;
